export const metros = [
    "Abilene, TX Metro",
    "Aguadilla, PR Metro",
    "Akron, OH Metro",
    "Albany-Schenectady-Troy, NY Metro",
    "Albany, GA Metro",
    "Albany, OR Metro",
    "Albuquerque, NM Metro",
    "Alexandria, LA Metro",
    "Allentown-Bethlehem-Easton, PA-NJ Metro",
    "Altoona, PA Metro",
    "Amarillo, TX Metro",
    "Ames, IA Metro",
    "Amherst Town-Northampton, MA Metro",
    "Anchorage, AK Metro",
    "Anderson, IN Metro",
    "Anderson, SC Metro",
    "Ann Arbor, MI Metro",
    "Anniston-Oxford, AL Metro",
    "Appleton, WI Metro",
    "Arecibo, PR Metro",
    "Asheville, NC Metro",
    "Athens-Clarke County, GA Metro",
    "Atlanta-Sandy Springs-Roswell, GA Metro",
    "Atlantic City-Hammonton, NJ Metro",
    "Auburn-Opelika, AL Metro",
    "Augusta-Richmond County, GA-SC Metro",
    "Austin-Round Rock-San Marcos, TX Metro",
    "Bakersfield-Delano, CA Metro",
    "Baltimore-Columbia-Towson, MD Metro",
    "Bangor, ME Metro",
    "Barnstable Town, MA Metro",
    "Baton Rouge, LA Metro",
    "Battle Creek, MI Metro",
    "Bay City, MI Metro",
    "Beaumont-Port Arthur, TX Metro",
    "Beckley, WV Metro",
    "Bellingham, WA Metro",
    "Bend, OR Metro",
    "Billings, MT Metro",
    "Binghamton, NY Metro",
    "Birmingham, AL Metro",
    "Bismarck, ND Metro",
    "Blacksburg-Christiansburg-Radford, VA Metro",
    "Bloomington, IL Metro",
    "Bloomington, IN Metro",
    "Bloomsburg-Berwick, PA Metro",
    "Boise City, ID Metro",
    "Boston-Cambridge-Newton, MA-NH Metro",
    "Boulder, CO Metro",
    "Bowling Green, KY Metro",
    "Bozeman, MT Metro",
    "Bremerton-Silverdale-Port Orchard, WA Metro",
    "Bridgeport-Stamford-Danbury, CT Metro",
    "Brownsville-Harlingen, TX Metro",
    "Brunswick-St. Simons, GA Metro",
    "Buffalo-Cheektowaga, NY Metro",
    "Burlington-South Burlington, VT Metro",
    "Burlington, NC Metro",
    "Canton-Massillon, OH Metro",
    "Cape Coral-Fort Myers, FL Metro",
    "Cape Girardeau, MO-IL Metro",
    "Carbondale, IL Metro",
    "Carson City, NV Metro",
    "Casper, WY Metro",
    "Cedar Rapids, IA Metro",
    "Chambersburg, PA Metro",
    "Champaign-Urbana, IL Metro",
    "Charleston-North Charleston, SC Metro",
    "Charleston, WV Metro",
    "Charlotte-Concord-Gastonia, NC-SC Metro",
    "Charlottesville, VA Metro",
    "Chattanooga, TN-GA Metro",
    "Cheyenne, WY Metro",
    "Chicago-Naperville-Elgin, IL-IN Metro",
    "Chico, CA Metro",
    "Cincinnati, OH-KY-IN Metro",
    "Clarksville, TN-KY Metro",
    "Cleveland, OH Metro",
    "Cleveland, TN Metro",
    "Coeur d'Alene, ID Metro",
    "College Station-Bryan, TX Metro",
    "Colorado Springs, CO Metro",
    "Columbia, MO Metro",
    "Columbia, SC Metro",
    "Columbus, GA-AL Metro",
    "Columbus, IN Metro",
    "Columbus, OH Metro",
    "Corpus Christi, TX Metro",
    "Corvallis, OR Metro",
    "Crestview-Fort Walton Beach-Destin, FL Metro",
    "Cumberland, MD-WV Metro",
    "Dallas-Fort Worth-Arlington, TX Metro",
    "Dalton, GA Metro",
    "Danville, IL Metro",
    "Danville, VA Metro",
    "Daphne-Fairhope-Foley, AL Metro",
    "Davenport-Moline-Rock Island, IA-IL Metro",
    "Dayton-Kettering-Beavercreek, OH Metro",
    "Decatur, AL Metro",
    "Decatur, IL Metro",
    "Deltona-Daytona Beach-Ormond Beach, FL Metro",
    "Denver-Aurora-Centennial, CO Metro",
    "Des Moines-West Des Moines, IA Metro",
    "Detroit-Warren-Dearborn, MI Metro",
    "Dothan, AL Metro",
    "Dover, DE Metro",
    "Dubuque, IA Metro",
    "Duluth, MN-WI Metro",
    "Durham-Chapel Hill, NC Metro",
    "Eagle Pass, TX Metro",
    "East Stroudsburg, PA Metro",
    "Eau Claire, WI Metro",
    "El Centro, CA Metro",
    "El Paso, TX Metro",
    "Elizabethtown, KY Metro",
    "Elkhart-Goshen, IN Metro",
    "Elmira, NY Metro",
    "Enid, OK Metro",
    "Erie, PA Metro",
    "Eugene-Springfield, OR Metro",
    "Evansville, IN Metro",
    "Fairbanks-College, AK Metro",
    "Fajardo, PR Metro",
    "Fargo, ND-MN Metro",
    "Farmington, NM Metro",
    "Fayetteville-Springdale-Rogers, AR Metro",
    "Fayetteville, NC Metro",
    "Flagstaff, AZ Metro",
    "Flint, MI Metro",
    "Florence-Muscle Shoals, AL Metro",
    "Florence, SC Metro",
    "Fond du Lac, WI Metro",
    "Fort Collins-Loveland, CO Metro",
    "Fort Smith, AR-OK Metro",
    "Fort Wayne, IN Metro",
    "Fresno, CA Metro",
    "Gadsden, AL Metro",
    "Gainesville, FL Metro",
    "Gainesville, GA Metro",
    "Gettysburg, PA Metro",
    "Glens Falls, NY Metro",
    "Goldsboro, NC Metro",
    "Grand Forks, ND-MN Metro",
    "Grand Island, NE Metro",
    "Grand Junction, CO Metro",
    "Grand Rapids-Wyoming-Kentwood, MI Metro",
    "Grants Pass, OR Metro",
    "Great Falls, MT Metro",
    "Greeley, CO Metro",
    "Green Bay, WI Metro",
    "Greensboro-High Point, NC Metro",
    "Greenville-Anderson-Greer, SC Metro",
    "Greenville-Mauldin-Easley, SC Metro",
    "Greenville, NC Metro",
    "Guayama, PR Metro",
    "Gulfport-Biloxi, MS Metro",
    "Hagerstown-Martinsburg, MD-WV Metro",
    "Hammond, LA Metro",
    "Hanford-Corcoran, CA Metro",
    "Harrisburg-Carlisle, PA Metro",
    "Harrisonburg, VA Metro",
    "Hartford-West Hartford-East Hartford, CT Metro",
    "Hattiesburg, MS Metro",
    "Helena, MT Metro",
    "Hickory-Lenoir-Morganton, NC Metro",
    "Hilton Head Island-Bluffton-Port Royal, SC Metro",
    "Hinesville, GA Metro",
    "Holland-Grand Haven, MI Metro",
    "Homosassa Springs, FL Metro",
    "Hot Springs, AR Metro",
    "Houma-Bayou Cane-Thibodaux, LA Metro",
    "Houston-Pasadena-The Woodlands, TX Metro",
    "Huntington-Ashland, WV-KY-OH Metro",
    "Huntsville, AL Metro",
    "Idaho Falls, ID Metro",
    "Indianapolis-Carmel-Greenwood, IN Metro",
    "Iowa City, IA Metro",
    "Ithaca, NY Metro",
    "Jackson, MI Metro",
    "Jackson, MS Metro",
    "Jackson, TN Metro",
    "Jacksonville, FL Metro",
    "Jacksonville, NC Metro",
    "Janesville-Beloit, WI Metro",
    "Jefferson City, MO Metro",
    "Johnson City, TN Metro",
    "Johnstown, PA Metro",
    "Jonesboro, AR Metro",
    "Joplin, MO-KS Metro",
    "Kahului-Wailuku, HI Metro",
    "Kalamazoo-Portage, MI Metro",
    "Kankakee, IL Metro",
    "Kansas City, MO-KS Metro",
    "Kennewick-Richland, WA Metro",
    "Kenosha, WI Metro",
    "Killeen-Temple, TX Metro",
    "Kingsport-Bristol, TN-VA Metro",
    "Kingston, NY Metro",
    "Kiryas Joel-Poughkeepsie-Newburgh, NY Metro",
    "Knoxville, TN Metro",
    "Kokomo, IN Metro",
    "La Crosse-Onalaska, WI-MN Metro",
    "Lafayette-West Lafayette, IN Metro",
    "Lafayette, LA Metro",
    "Lake Charles, LA Metro",
    "Lake Havasu City-Kingman, AZ Metro",
    "Lakeland-Winter Haven, FL Metro",
    "Lancaster, PA Metro",
    "Lansing-East Lansing, MI Metro",
    "Laredo, TX Metro",
    "Las Cruces, NM Metro",
    "Las Vegas-Henderson-North Las Vegas, NV Metro",
    "Lawrence, KS Metro",
    "Lawton, OK Metro",
    "Lebanon, PA Metro",
    "Lewiston-Auburn, ME Metro",
    "Lewiston, ID-WA Metro",
    "Lexington Park, MD Metro",
    "Lexington-Fayette, KY Metro",
    "Lima, OH Metro",
    "Lincoln, NE Metro",
    "Little Rock-North Little Rock-Conway, AR Metro",
    "Logan, UT-ID Metro",
    "Longview-Kelso, WA Metro",
    "Longview, TX Metro",
    "Los Angeles-Long Beach-Anaheim, CA Metro",
    "Louisville/Jefferson County, KY-IN Metro",
    "Lubbock, TX Metro",
    "Lynchburg, VA Metro",
    "Macon-Bibb County, GA Metro",
    "Madera, CA Metro",
    "Madison, WI Metro",
    "Manchester-Nashua, NH Metro",
    "Manhattan, KS Metro",
    "Mankato, MN Metro",
    "Mansfield, OH Metro",
    "Mayagüez, PR Metro",
    "McAllen-Edinburg-Mission, TX Metro",
    "Medford, OR Metro",
    "Memphis, TN-MS-AR Metro",
    "Merced, CA Metro",
    "Miami-Fort Lauderdale-West Palm Beach, FL Metro",
    "Michigan City-La Porte, IN Metro",
    "Midland, MI Metro",
    "Midland, TX Metro",
    "Milwaukee-Waukesha, WI Metro",
    "Minneapolis-St. Paul-Bloomington, MN-WI Metro",
    "Minot, ND Metro",
    "Missoula, MT Metro",
    "Mobile, AL Metro",
    "Modesto, CA Metro",
    "Monroe, LA Metro",
    "Monroe, MI Metro",
    "Montgomery, AL Metro",
    "Morgantown, WV Metro",
    "Morristown, TN Metro",
    "Mount Vernon-Anacortes, WA Metro",
    "Muncie, IN Metro",
    "Muskegon-Norton Shores, MI Metro",
    "Myrtle Beach-Conway-North Myrtle Beach, SC Metro",
    "Napa, CA Metro",
    "Naples-Marco Island, FL Metro",
    "Nashville-Davidson--Murfreesboro--Franklin, TN Metro",
    "New Bern, NC Metro",
    "New Haven, CT Metro",
    "New Orleans-Metairie, LA Metro",
    "New York-Newark-Jersey City, NY-NJ Metro",
    "Niles, MI Metro",
    "North Port-Bradenton-Sarasota, FL Metro",
    "Norwich-New London-Willimantic, CT Metro",
    "Ocala, FL Metro",
    "Ocean City, NJ Metro",
    "Odessa, TX Metro",
    "Ogden, UT Metro",
    "Oklahoma City, OK Metro",
    "Olympia-Lacey-Tumwater, WA Metro",
    "Omaha, NE-IA Metro",
    "Orlando-Kissimmee-Sanford, FL Metro",
    "Oshkosh-Neenah, WI Metro",
    "Owensboro, KY Metro",
    "Oxnard-Thousand Oaks-Ventura, CA Metro",
    "Paducah, KY-IL Metro",
    "Palm Bay-Melbourne-Titusville, FL Metro",
    "Palm Coast, FL Metro",
    "Panama City-Panama City Beach, FL Metro",
    "Parkersburg-Vienna, WV Metro",
    "Pascagoula, MS Metro",
    "Pensacola-Ferry Pass-Brent, FL Metro",
    "Peoria, IL Metro",
    "Philadelphia-Camden-Wilmington, PA-NJ-DE-MD Metro",
    "Phoenix-Mesa-Chandler, AZ Metro",
    "Pine Bluff, AR Metro",
    "Pinehurst-Southern Pines, NC Metro",
    "Pittsburgh, PA Metro",
    "Pittsfield, MA Metro",
    "Pocatello, ID Metro",
    "Ponce, PR Metro",
    "Port St. Lucie, FL Metro",
    "Portland-South Portland, ME Metro",
    "Portland-Vancouver-Hillsboro, OR-WA Metro",
    "Prescott Valley-Prescott, AZ Metro",
    "Providence-Warwick, RI-MA Metro",
    "Provo-Orem-Lehi, UT Metro",
    "Pueblo, CO Metro",
    "Punta Gorda, FL Metro",
    "Racine-Mount Pleasant, WI Metro",
    "Raleigh-Cary, NC Metro",
    "Rapid City, SD Metro",
    "Reading, PA Metro",
    "Redding, CA Metro",
    "Reno, NV Metro",
    "Richmond, VA Metro",
    "Riverside-San Bernardino-Ontario, CA Metro",
    "Roanoke, VA Metro",
    "Rochester, MN Metro",
    "Rochester, NY Metro",
    "Rockford, IL Metro",
    "Rocky Mount, NC Metro",
    "Rome, GA Metro",
    "Sacramento-Roseville-Folsom, CA Metro",
    "Saginaw, MI Metro",
    "Salem, OR Metro",
    "Salinas, CA Metro",
    "Salisbury, MD Metro",
    "Salt Lake City-Murray, UT Metro",
    "San Angelo, TX Metro",
    "San Antonio-New Braunfels, TX Metro",
    "San Diego-Chula Vista-Carlsbad, CA Metro",
    "San Francisco-Oakland-Fremont, CA Metro",
    "San Germán, PR Metro",
    "San Jose-Sunnyvale-Santa Clara, CA Metro",
    "San Juan-Bayamón-Caguas, PR Metro",
    "San Luis Obispo-Paso Robles, CA Metro",
    "Sandusky, OH Metro",
    "Santa Cruz-Watsonville, CA Metro",
    "Santa Fe, NM Metro",
    "Santa Maria-Santa Barbara, CA Metro",
    "Santa Rosa-Petaluma, CA Metro",
    "Savannah, GA Metro",
    "Scranton--Wilkes-Barre, PA Metro",
    "Seattle-Tacoma-Bellevue, WA Metro",
    "Sebastian-Vero Beach-West Vero Corridor, FL Metro",
    "Sebring, FL Metro",
    "Sheboygan, WI Metro",
    "Sherman-Denison, TX Metro",
    "Shreveport-Bossier City, LA Metro",
    "Sierra Vista-Douglas, AZ Metro",
    "Sioux City, IA-NE-SD Metro",
    "Sioux Falls, SD-MN Metro",
    "Slidell-Mandeville-Covington, LA Metro",
    "South Bend-Mishawaka, IN-MI Metro",
    "Spartanburg, SC Metro",
    "Spokane-Spokane Valley, WA Metro",
    "Springfield, IL Metro",
    "Springfield, MA Metro",
    "Springfield, MO Metro",
    "Springfield, OH Metro",
    "St. Cloud, MN Metro",
    "St. George, UT Metro",
    "St. Joseph, MO-KS Metro",
    "St. Louis, MO-IL Metro",
    "State College, PA Metro",
    "Staunton-Stuarts Draft, VA Metro",
    "Stockton-Lodi, CA Metro",
    "Sumter, SC Metro",
    "Syracuse, NY Metro",
    "Tallahassee, FL Metro",
    "Tampa-St. Petersburg-Clearwater, FL Metro",
    "Terre Haute, IN Metro",
    "Texarkana, TX-AR Metro",
    "Toledo, OH Metro",
    "Topeka, KS Metro",
    "Traverse City, MI Metro",
    "Trenton-Princeton, NJ Metro",
    "Tucson, AZ Metro",
    "Tulsa, OK Metro",
    "Tuscaloosa, AL Metro",
    "Twin Falls, ID Metro",
    "Tyler, TX Metro",
    "Urban Honolulu, HI Metro",
    "Utica-Rome, NY Metro",
    "Valdosta, GA Metro",
    "Vallejo, CA Metro",
    "Victoria, TX Metro",
    "Vineland, NJ Metro",
    "Virginia Beach-Chesapeake-Norfolk, VA-NC Metro",
    "Visalia, CA Metro",
    "Waco, TX Metro",
    "Walla Walla, WA Metro",
    "Warner Robins, GA Metro",
    "Washington-Arlington-Alexandria, DC-VA-MD-WV Metro",
    "Waterbury-Shelton, CT Metro",
    "Waterloo-Cedar Falls, IA Metro",
    "Watertown-Fort Drum, NY Metro",
    "Wausau, WI Metro",
    "Weirton-Steubenville, WV-OH Metro",
    "Wenatchee-East Wenatchee, WA Metro",
    "Wheeling, WV-OH Metro",
    "Wichita Falls, TX Metro",
    "Wichita, KS Metro",
    "Wildwood-The Villages, FL Metro",
    "Williamsport, PA Metro",
    "Wilmington, NC Metro",
    "Winchester, VA-WV Metro",
    "Winston-Salem, NC Metro",
    "Worcester, MA Metro",
    "Yakima, WA Metro",
    "Yauco, PR Metro",
    "York-Hanover, PA Metro",
    "Youngstown-Warren, OH Metro",
    "Yuba City, CA Metro",
    "Yuma, AZ Metro"
];